import { render, staticRenderFns } from "./player-time.vue?vue&type=template&id=229920f7&scoped=true&"
import script from "./player-time.vue?vue&type=script&lang=ts&"
export * from "./player-time.vue?vue&type=script&lang=ts&"
import style0 from "./player-time.vue?vue&type=style&index=0&id=229920f7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229920f7",
  null
  
)

export default component.exports